<template>
    <v-container>
        <v-layout row wrap pt-4>
            <v-flex xs12>
                    <h1>Federal Election {{ year }}</h1>
            </v-flex>
        </v-layout>
        <v-layout row wrap pt-4>
            <v-flex xs12>
                <h2>{{ pollingPlace }}</h2>
            </v-flex>
        </v-layout>
        <br/>
        <h2>First preferences</h2>
        <br/>
        <first-preferences-polling-place :pollingPlace="pollingPlace" :division="division" :year="year"></first-preferences-polling-place>
        <br/>
        <h2>Two candidate preferred</h2>
        <br/>
        <two-candidate-preferred-by-polling-place :pollingPlace="pollingPlace" :division="division" :year="year"></two-candidate-preferred-by-polling-place>
        <br/>
    </v-container>
</template>
<script>
    import axios from 'axios';
    window.Handbook = window.Handbook || {}
    const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
    axios.defaults.baseURL = apiUri;

    import FirstPreferencesPollingPlace from './FirstPreferencesPollingPlace.vue';
    import TwoCandidatePreferredByPollingPlace from './TwoCandidatePreferredByPollingPlace.vue';

    export default {
        props: ['pollingPlace', 'division', 'year'],
        components: {
            FirstPreferencesPollingPlace,
            TwoCandidatePreferredByPollingPlace
        }
    }
</script>